import { useParams } from "@tanstack/react-router";

/**
 * useObraId lee el id de obra activa del contexto de ruta (`/obras/$obraId/...`). Las
 * páginas de dominio cuelgan de `obraLayoutRoute`, cuyo `beforeLoad` (#157) ya validó
 * que `$obraId` es un entero positivo del que el usuario es miembro, así que aquí el
 * valor es siempre un número válido. `strict: false` evita acoplar la página a un id de
 * ruta concreto (mismo patrón que la ficha de LOTO para leer su `$id`).
 */
export function useObraId(): number {
  const { obraId } = useParams({ strict: false });
  return Number(obraId);
}
